import { render, staticRenderFns } from "./giftcardSidebar.vue?vue&type=template&id=3f2e0816&scoped=true&"
import script from "./giftcardSidebar.vue?vue&type=script&lang=js&"
export * from "./giftcardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./giftcardSidebar.vue?vue&type=style&index=0&id=3f2e0816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2e0816",
  null
  
)

export default component.exports